import {
  InteractionRequiredAuthError,
  PublicClientApplication,
} from '@azure/msal-browser';
import { msalInstance } from 'index';

type requestFunction = (
  endpoint: string,
  body?: any,
  options?: {
    noAuth?: boolean;
    method?: 'GET' | 'PUT' | 'POST' | 'DELETE' | 'PATCH';
  },
  authRetry?: boolean
) => Promise<Response>;

const request: requestFunction = async (
  endpoint,
  body,
  options,
  authRetry?
) => {
  const fetchOptions: any = {
    method: options?.method || 'GET',
    headers: {
      Accept: 'application/json',
    },
  };

  if (body) {
    fetchOptions.body = JSON.stringify(body);
    fetchOptions.headers['Content-Type'] = 'application/json';
  }
  if (!options?.noAuth) {
    const token = await acquireAccessToken(msalInstance);
    fetchOptions.headers['Authorization'] = 'Bearer ' + token;
  }

  const response = await fetch(endpoint, fetchOptions);
  if (response.status === 401 && !options?.noAuth) {
    if (authRetry) {
      return response;
    }
    await acquireAccessToken(msalInstance);
    return request(endpoint, body, options, true);
  }
  return response;
};

export const acquireAccessToken = async (
  msalInstance: PublicClientApplication
) => {
  const activeAccount = msalInstance.getActiveAccount(); // This will only return a non-null value if you have logic somewhere else that calls the setActiveAccount API
  const accounts = msalInstance.getAllAccounts();

  if (!activeAccount && accounts.length === 0) {
    window.location.href = '/'; // the user is not signed in. let's move him to the main page and force login
  }

  const request = {
    scopes: [process.env.REACT_APP_ACCESS_SCOPE as string],
    account: activeAccount || accounts[0],
  };

  try {
    const authResult = await msalInstance.acquireTokenSilent(request);

    return authResult.accessToken;
  } catch (error) {
    // Azure AD SPA refresh tokens expire after 24h and cannot be renewed silently.
    if (error instanceof InteractionRequiredAuthError) {
      await msalInstance.acquireTokenRedirect(request);
    }

    throw error;
  }
};

export { request };
